<script setup>
import {ref, reactive} from "vue";
import {useRoute, useRouter} from "vue-router";
import {useStore} from "vuex";
import {ElMessage} from 'element-plus'
import {Lock, User} from "@element-plus/icons-vue";
import {loginApi} from "@/service/index.js";

const store = useStore()
const router = useRouter()
const route = useRoute()
const rules = reactive({
  account: [
    {required: true, message: '请输入账号', trigger: 'blur'},
    {min: 2, max: 25, message: '请输入正确的账号', trigger: 'blur'},
  ],
  password: [
    {required: true, message: '请输入密码', trigger: 'blur'},
    {min: 2, max: 25, message: '请输入正确的密码', trigger: 'blur'},
  ],
  captcha: [
    {required: true, message: '请输入验证码', trigger: 'blur'},
    {min: 4, max: 4, message: '请输入正确的验证码', trigger: 'blur'},
  ],
})
let lForm = ref(null)
let form = ref({
  account: '',
  password: '',
  captcha: '',// 验证码
  captcha_id: '',	// 调用验证码生成的ID
})
// 跟注册一致：时间戳生成验证码ID，点击图片刷新
const updateCaptcha = () => {
  form.value.captcha_id = new Date().valueOf().toString().slice(4, -1)
}
const login = async () => {
  await lForm.value.validate((valid, fields) => {
    if (valid) {
      loginApi(form.value).then(res => {
        if (res.data.code == 1) {
          ElMessage({
            message: '登录成功',
            type: 'success',
          })
          store.commit('setUserInfo', res.data.data.userinfo)
          localStorage.setItem('userInfo', JSON.stringify(res.data.data.userinfo))
          // 登录成功后回原来想访问的页面（只允许本站路径）
          const redirect = route.query.redirect
          const go = (typeof redirect === 'string' && redirect.startsWith('/') && !redirect.startsWith('//')) ? redirect : '/'
          router.push(go)
        } else {
          ElMessage({
            message: res.data.msg,
            type: 'warning',
          })
          // 验证码已失效，换一张重新输入
          form.value.captcha = ''
          updateCaptcha()
        }
      })
    } else {
      console.log('error submit!', fields)
    }
  })
}
updateCaptcha()
</script>

<template>
  <div class="login-box">
    <div class="login-card">
      <div class="login-title">
        <span>登录</span>
      </div>
      <el-form :rules="rules" class="login-form" :model="form" ref="lForm" @submit.prevent>
        <el-form-item size="large" prop="account">
          <el-input style="height: 50px" size="large" v-model="form.account" placeholder="请输入用户名或邮箱或手机号登录"
                    @keyup.enter="login">
            <template #prepend>
              <el-icon size="15">
                <User/>
              </el-icon>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item size="large" prop="password">
          <el-input style="height: 50px" size="large" v-model="form.password" type="password" placeholder="请输入密码"
                    @keyup.enter="login">
            <template #prepend>
              <el-icon size="15">
                <Lock/>
              </el-icon>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item size="large" prop="captcha">
          <div class="captcha-row">
            <el-input size="large" class="captcha-input" v-model="form.captcha" placeholder="请输入验证码"
                      @keyup.enter="login"/>
            <img :src="'https://aaap.trackcbec.com/index?s=captcha/' + form.captcha_id" @click="updateCaptcha"
                 v-if="form.captcha_id" class="captcha-pic" alt="">
          </div>
        </el-form-item>
        <el-button type="primary" size="large" class="login-btn" @click="login">登 录</el-button>
      </el-form>
    </div>
    <p class="disclaimer">本系统只提供界面可视化业务服务，用户应自行核实其准确性。对于因使用本系统而产生的任何法律后果，本公司不承担任何责任。</p>
  </div>
</template>

<style lang="less" scoped>
.login-box {
  width: 100vw;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;

  .login-card {
    width: 460px;
    background: #fff;
    border-radius: 10px;
    padding: 40px 44px 24px;
    box-sizing: border-box;
    box-shadow: 0 0 20px 0 rgba(0, 0, 0, .15);

    .login-title {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 30px;

      img {
        width: 40px;
        margin-right: 10px;
      }
    }

    .login-btn {
      width: 100%;
      height: 50px;
      font-size: 18px;
      margin-top: 10px;
    }

    .captcha-row {
      display: flex;
      align-items: center;
      width: 100%;

      .captcha-input {
        flex: 1;
      }

      .captcha-pic {
        width: 120px;
        margin-left: 20px;
        cursor: pointer;
      }
    }

    .login-foot {
      display: flex;
      justify-content: flex-end;
      margin-top: 18px;
      font-size: 14px;

      .foot-link {
        cursor: pointer;
        color: rgb(53, 152, 219);
      }
    }
  }

  .disclaimer {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 12px;
    margin: 0;
    padding: 0 24px;
    text-align: center;
    font-size: 12px;
    color: #909399;
    line-height: 1.6;
  }
}
</style>
